"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useEffect, useRef } from "react";
import type { ReactNode } from "react";
type NavBarVisibilityContextValue = {
  visible: boolean;
  setVisible: (visible: boolean) => void;
};
const NavBarVisibilityContext = createContext<NavBarVisibilityContextValue | null>(null);
export const NavBarVisibilityProvider = t0 => {
  const $ = _c(3);
  const {
    value,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <NavBarVisibilityContext.Provider value={value}>{children}</NavBarVisibilityContext.Provider>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const useNavBarVisibility = () => {
  const context = useContext(NavBarVisibilityContext);
  if (!context) {
    throw new Error("useNavBarVisibility must be used within a provider");
  }
  return context;
};
export const useOptionalNavBarVisibility = () => {
  return useContext(NavBarVisibilityContext);
};
export const NavBarVisibility = t0 => {
  const $ = _c(7);
  const {
    visible
  } = t0;
  const {
    visible: currentVisible,
    setVisible
  } = useNavBarVisibility();
  const previousVisible = useRef(currentVisible);
  let t1;
  if ($[0] !== currentVisible || $[1] !== setVisible || $[2] !== visible) {
    t1 = () => {
      previousVisible.current = currentVisible;
      setVisible(visible);
      return () => {
        setVisible(previousVisible.current);
      };
    };
    $[0] = currentVisible;
    $[1] = setVisible;
    $[2] = visible;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== setVisible || $[5] !== visible) {
    t2 = [visible, setVisible];
    $[4] = setVisible;
    $[5] = visible;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  return null;
};